import './profile.css'
import {useAuthValue} from './AuthContext'
import { signOut } from 'firebase/auth' 
import { auth, db } from './firebase'
import {useState, React, useEffect} from 'react'
import logoImg1 from './assets/logoG.png';
import imgwhats from './assets/imageWhats.png'
import {useNavigate,  useLocation} from 'react-router-dom'


function CashbackSuccess() {
    const navigate = useNavigate()
    const location = useLocation()
    const currDate = new Date().toLocaleString() + '';
    
    const removemaskPhone = (valphonenum) => {
      const nummob =  valphonenum?.replace(/[^0-9]/g, '') ?? 0;
      return nummob; 
    }
    const telefonecli = removemaskPhone(location.state.foneClie);
    return (
        <div className='center'>
          <div className='profile'>
            <img src={logoImg1} width="150" height="150"/>
            <h1>Cashback Registrado com Sucesso!</h1>
            <h3 style={{color:"darkred"}}>Compra ID: {location.state.codLanc}</h3>
            <hr/>
             <p><strong>Informe ao seu cliente que dentro de algumas horas o valor da sua carteira digital estará atualizado</strong></p>
            <hr/>
            <p><strong>Data:</strong> {currDate}</p>
            <p><strong>Cliente:</strong> {location.state.nomeCli}</p>
            <p><strong>Fone:</strong> {location.state.foneClie}</p>
            <hr/>
            <h3 style={{color:"darkgreen"}}> Serviço </h3>
            <hr/>
            <p><strong>Valor Pago:</strong> R$ {location.state.valorServ}</p>
            <p><strong>Cashback Cliente:</strong> R$ {(location.state.valorCash/10).toFixed(2)}</p>
            <hr/>
            <a href={`https://api.whatsapp.com/send?phone=55${telefonecli}&text=Voce%20ganhou%20Cashback%20pelo%20aplicativo%20TOPago%20Cashback`}  target="_blank">
            <img src={imgwhats} width="139" height="45"/>
            </a>
            <hr/>
             <button onClick={() => navigate('/profile')} style={{backgroundColor:"green",  color:'white'}}>Fechar</button>
            
             
            
         
            </div>
        </div>
        )

}


export default CashbackSuccess